var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-table",
        { attrs: { border: "", align: "center", data: _vm.list } },
        [
          _c("el-table-column", {
            attrs: {
              align: "center",
              label: "序号",
              type: "index",
              width: "60",
            },
          }),
          _c("el-table-column", {
            attrs: { prop: "giftCode", label: "礼品编码" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("el-input", {
                      attrs: { disabled: _vm.disabled },
                      on: { change: _vm.toFather },
                      model: {
                        value: scope.row.giftCode,
                        callback: function ($$v) {
                          _vm.$set(scope.row, "giftCode", $$v)
                        },
                        expression: "scope.row.giftCode",
                      },
                    }),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { prop: "giftName", label: "礼品名称" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("el-input", {
                      attrs: { disabled: _vm.disabled },
                      on: { change: _vm.toFather },
                      model: {
                        value: scope.row.giftName,
                        callback: function ($$v) {
                          _vm.$set(scope.row, "giftName", $$v)
                        },
                        expression: "scope.row.giftName",
                      },
                    }),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { prop: "giftRemark", label: "礼品描述" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("el-input", {
                      attrs: { disabled: _vm.disabled },
                      on: { change: _vm.toFather },
                      model: {
                        value: scope.row.giftRemark,
                        callback: function ($$v) {
                          _vm.$set(scope.row, "giftRemark", $$v)
                        },
                        expression: "scope.row.giftRemark",
                      },
                    }),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { prop: "giftUnit", label: "单位" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("el-input", {
                      attrs: { disabled: _vm.disabled },
                      on: { change: _vm.toFather },
                      model: {
                        value: scope.row.giftUnit,
                        callback: function ($$v) {
                          _vm.$set(scope.row, "giftUnit", $$v)
                        },
                        expression: "scope.row.giftUnit",
                      },
                    }),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { prop: "priceAmount", label: "核销积分/分" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("el-input-number", {
                      attrs: { disabled: _vm.disabled },
                      on: { change: _vm.toFather },
                      model: {
                        value: scope.row.priceAmount,
                        callback: function ($$v) {
                          _vm.$set(scope.row, "priceAmount", $$v)
                        },
                        expression: "scope.row.priceAmount",
                      },
                    }),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { prop: "giftPic", label: "礼品图片" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c(
                      "div",
                      [
                        _c("UploadImage", {
                          attrs: {
                            value: scope.row.giftPic,
                            disabled: _vm.disabled,
                          },
                          on: {
                            change: function (files) {
                              return _vm.changeFiles(files, scope.row)
                            },
                          },
                        }),
                      ],
                      1
                    ),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }